/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 * React 19 compatible replacement for react-chat-ui ChatFeed
 */

import React from 'react';
import PropTypes from 'prop-types';
import ChatBubble from './ChatBubble';

const ChatFeed = ({ 
    messages = [], 
    isTyping = false, 
    hasInputField = false, 
    showSenderName = false, 
    bubblesCentered = false,
    customBubble = null
}) => {
    return (
        <div style={{ width: '100%' }}>
            {messages.map((message, index) => {
                // Use message.id for key if available, otherwise fall back to index
                const messageKey = message.id !== undefined ? message.id : index;
                
                return (
                    <div key={messageKey} style={{ marginBottom: '10px' }}>
                        {showSenderName && message.senderName && (
                            <div style={{ fontSize: '12px', color: '#666', marginBottom: '5px' }}>
                                {message.senderName}
                            </div>
                        )}
                        <ChatBubble 
                            message={message} 
                            bubbleStyles={message.bubbleStyles}
                            customBubble={customBubble}
                        />
                    </div>
                );
            })}
            {isTyping && (
                <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    marginTop: '10px',
                    color: '#666',
                    fontSize: '14px'
                }}>
                    <div style={{ 
                        display: 'inline-block',
                        width: '20px',
                        height: '20px',
                        marginRight: '10px'
                    }}>
                        <div style={{
                            width: '4px',
                            height: '4px',
                            backgroundColor: '#666',
                            borderRadius: '50%',
                            display: 'inline-block',
                            marginRight: '2px',
                            animation: 'typing 1.4s infinite ease-in-out both'
                        }}></div>
                        <div style={{
                            width: '4px',
                            height: '4px',
                            backgroundColor: '#666',
                            borderRadius: '50%',
                            display: 'inline-block',
                            marginRight: '2px',
                            animation: 'typing 1.4s infinite ease-in-out both',
                            animationDelay: '0.2s'
                        }}></div>
                        <div style={{
                            width: '4px',
                            height: '4px',
                            backgroundColor: '#666',
                            borderRadius: '50%',
                            display: 'inline-block',
                            animation: 'typing 1.4s infinite ease-in-out both',
                            animationDelay: '0.4s'
                        }}></div>
                    </div>
                    Typing...
                </div>
            )}
            <style jsx>{`
                @keyframes typing {
                    0%, 80%, 100% {
                        transform: scale(0);
                        opacity: 0.5;
                    }
                    40% {
                        transform: scale(1);
                        opacity: 1;
                    }
                }
            `}</style>
        </div>
    );
};

ChatFeed.propTypes = {
    messages: PropTypes.array,
    isTyping: PropTypes.bool,
    hasInputField: PropTypes.bool,
    showSenderName: PropTypes.bool,
    bubblesCentered: PropTypes.bool,
    customBubble: PropTypes.func
};

export default ChatFeed;
